import { Loadable } from '../Loadable';

export const AsyncPromoCodeList = Loadable(() => import('./PromoCodeList'));
export const AsyncAddPromoCode = Loadable(() => import('./AddPromoCode'));
